import { Component } from '@angular/core';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import { ImageCdnSrcDirective } from '@polaris-customerweb/sharedcomponents.shared';

@Component({
    imports: [ImageCdnSrcDirective],
    selector: 'rdx-no-navigation-header',
    styleUrls: ['./no-navigation-header.component.scss'],
    templateUrl: './no-navigation-header.component.html',
})
export class NoNavigationHeaderComponent {
    brand: string;

    constructor(configService: ConfigService) {
        this.brand = configService.brand;
    }
}
